import { render, staticRenderFns } from "./offline_order_list.vue?vue&type=template&id=67dcecc6&scoped=true"
import script from "./offline_order_list.vue?vue&type=script&lang=js"
export * from "./offline_order_list.vue?vue&type=script&lang=js"
import style0 from "./offline_order_list.vue?vue&type=style&index=0&id=67dcecc6&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67dcecc6",
  null
  
)

export default component.exports